import './bootstrap.scss';
import './index.scss';
import './components/scss/mustache-editor.scss';

import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import * as bd from 'react-basic-design';
import ReactDOM from 'react-dom/client';
import './i18n/index';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './app/stores/store';

//-----------
var t = bd.helper.getTheme();
bd.helper.setTheme(
    !t || bd.helper.getTheme() == 'bd-light' ? 'bd-quartz-light' : t.replace(' ', '')
);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('root element not found');

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);
